const URL_REGEX = /(https?:\/\/[^\s]+)/g;

export const parseLessonDescription = (text = "") => {
  const normalizedText = String(text ?? "");

  if (!normalizedText) {
    return {
      hasLink: false,
      beforeLink: "",
      link: "",
      afterLink: "",
    };
  }

  const parts = normalizedText.split(URL_REGEX);

  return {
    hasLink: /(https?:\/\/[^\s]+)/.test(normalizedText),
    beforeLink: parts[0] ?? "",
    link: parts[1] ?? "",
    afterLink: parts[2] ?? "",
  };
};
